/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

const reference =  `[
  "rows.banner.reference.link_list",
  "rows.product_feature.reference.variant_b",
  "rows.product_feature.reference.variant_a",
  "rows.merchandising.reference",
  "rows.interactive.reference",
  "rows.tiles.reference.tiles_5up_ctaonly",
  "rows.tiles.reference.tiles_5up_standard_headingcta",
  "rows.tiles.reference.variant_a",
  "rows.tiles.reference.variant_b",
  "rows.tiles.reference.variant_c",
  "rows.tiles.reference.half",
  "rows.tiles.reference.color",
  "rows.tiles.reference.simple",
  "rows.tiles.reference.full",
  "rows.tiles.reference.variant_d",
  "rows.tiles.reference.review",
]`;
export default reference;
